/**
 * Lead delivery for the branded partner-college landing pages (CCU, GTC, HCU,
 * UAGC, UMA). These pages do not go through Media Matchers — each partner has
 * its own destination.
 *
 * The previous Zapier catch hooks have been removed and are pending
 * replacement. Until an endpoint is filled in below, submissions are collected
 * and validated as normal but not transmitted anywhere; the visitor still
 * reaches the thank-you page.
 */
export const PARTNER_LEAD_ENDPOINTS: Record<string, string> = {
  ccu: '',
  gtc: '',
  hcu: '',
  uagc: '',
  uma: '',
}

/**
 * Sends the lead to the partner's endpoint. A blank endpoint is a no-op, so the
 * calling page's flow is identical whether or not delivery is configured.
 *
 * Returns true when the request was actually attempted.
 */
export async function submitPartnerLead(
  partnerKey: keyof typeof PARTNER_LEAD_ENDPOINTS | string,
  params: URLSearchParams,
): Promise<boolean> {
  const endpoint = PARTNER_LEAD_ENDPOINTS[partnerKey]
  if (!endpoint) return false
  const separator = endpoint.includes('?') ? '&' : '?'
  await fetch(`${endpoint}${separator}${params.toString()}`, {
    method: 'GET',
    mode: 'no-cors',
  })
  return true
}
